// extracted by mini-css-extract-plugin
export default {"sticky-column":"Table_sticky-column__Y+kaq"};